import React, { useEffect } from 'react';
import { reportToSegment, types } from '@smartcar/morse';
import { bool, string } from 'prop-types';
import { Box, Typography } from '@mui/material';

import staticText from '../../../../../../../../localization/Application/webhooks';
import { Banner, InlineLinks, InputField } from '../../../../../../../../components';

const WebhookVerify = ({
  previouslyVerified,
  requiresReverification,
  errorSavingWebhook,
  errorVerifyingWebhook,
  webhookVerificationError,
}) => {
  const verifyText = staticText.addModal.stepperSections[4];

  useEffect(() => {
    reportToSegment(types.PAGE, 'Webhook Form - Verify');
  }, []);

  return (
    <div>
      <Typography variant="h1">{verifyText.title}</Typography>

      <Box marginTop={3}>
        {previouslyVerified && (
          <Banner severity="success">
            <Typography variant="body2">
              {verifyText.reverification.notRequired}
            </Typography>
          </Banner>
        )}
        {requiresReverification && (
          <Banner severity="warning">
            <Typography variant="body2">
              {verifyText.reverification.required}
            </Typography>
          </Banner>
        )}
        {errorSavingWebhook && (
          <Banner severity="error">
            <Typography variant="body2">
              {staticText.addModal.errors.savingWebhook}
            </Typography>
          </Banner>
        )}
        {errorVerifyingWebhook && (
          <Banner severity="error">
            <Typography variant="body2">
              {staticText.addModal.errors.verifyingWebhook}
            </Typography >
            {webhookVerificationError && <Typography variant="body2">Error: {webhookVerificationError}</Typography>}
          </Banner>
        )}
      </Box>

      <Box marginTop={3} display="flex" flexDirection="column" gap={2}>
        <Typography variant="body2">{verifyText.verification}</Typography>
        <InputField
          inputValues={verifyText.code}
          inputReadOnly
          inputName="code"
        />
        <Typography variant="body2"><InlineLinks text={verifyText.documentation} /></Typography>
        <Typography variant="body2">{verifyText.skip}</Typography>
      </Box>
    </div>
  );
};

export default WebhookVerify;

WebhookVerify.propTypes = {
  previouslyVerified: bool.isRequired,
  requiresReverification: bool.isRequired,
  errorSavingWebhook: bool.isRequired,
  errorVerifyingWebhook: bool.isRequired,
  webhookVerificationError: string,
};

WebhookVerify.defaultProps = {
  webhookVerificationError: null,
};
